import { render, staticRenderFns } from "./ProjectSection.vue?vue&type=template&id=4c3e2c03&scoped=true&"
import script from "./ProjectSection.vue?vue&type=script&lang=js&"
export * from "./ProjectSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSection.vue?vue&type=style&index=0&id=4c3e2c03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3e2c03",
  null
  
)

export default component.exports